export default "__VITE_ASSET__Bto2Nhoc__"